// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__34tlT","header":"PatientBlock_header__1yzup","label":"PatientBlock_label__3M5H0","option":"PatientBlock_option__3ccgF"};